
import LanguagePicker from "./LanguagePicker.vue";
import UserMenu from "./UserMenu.vue";

interface NavItem {
  icon: String;
  title: String;
  link: String;
  userTypes: [];
  requiresGroup?: String;
}

export default {
  components: { LanguagePicker, UserMenu },
  name: "NavigationDrawer",
  props: {
    items: Array as () => NavItem[],
  },
  data() {
    return {
      active: null as NavItem,
      drawerOpen: false,
      miniVariant: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.miniVariant = !this.miniVariant;
      // Store preference in localStorage
      localStorage.setItem('sidebarMini', this.miniVariant.toString());
    },
    handleItemClick() {
      if (!this.$vuetify.breakpoint.mdAndUp) {
        this.drawer = false;
      }
    },
    isActive(link: string) {
      return this.$route.path === link;
    },
    canShowItem(item: NavItem) {
      // Check user type first
      if (item.userTypes && !item.userTypes.includes(this.userType)) {
        return false;
      }

      // Check group-based access if required
      if (item.requiresGroup) {
        return this.hasRequiredGroup(item.requiresGroup);
      }

      return true;
    },
    hasRequiredGroup(groupName: string) {
      if (!this.currentUser) {
        return false;
      }

      // Check if user has employee.user_group (for employees)
      if (this.currentUser.employee && this.currentUser.employee.user_group) {
        const userGroupName = this.currentUser.employee.user_group.name;
        return userGroupName === groupName || 
               userGroupName === groupName.toLowerCase() ||
               userGroupName === groupName.charAt(0).toUpperCase() + groupName.slice(1);
      }

      // Fallback: Check for user_groups array (if structure changes in future)
      if (this.currentUser.user_groups) {
        return this.currentUser.user_groups.some((group: any) => 
          group.name === groupName || group.name === groupName.toLowerCase() ||
          group.name === groupName.charAt(0).toUpperCase() + groupName.slice(1)
        );
      }

      return false;
    },
    getItemLink(item: NavItem) {
      return item.link;
    },
  },
  mounted() {
    // Restore sidebar state from localStorage
    const savedState = localStorage.getItem('sidebarMini');
    if (savedState !== null) {
      this.miniVariant = savedState === 'true';
    }
  },
  computed: {
    drawer: {
      get() {
        return this.$vuetify.breakpoint.mdAndUp ? true : this.drawerOpen;
      },
      set(val) {
        if (!this.$vuetify.breakpoint.mdAndUp) {
          this.drawerOpen = val;
        }
      },
    },
    visibleItems() {
      return this.items.filter(item => this.canShowItem(item));
    },
    currentUser() {
      return this.$store.getters.stateUser;
    },
    userType() {
      return this.$store.getters.userType;
    },
  },
};
